var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"bbb-dmn-booking-container"},[(!_vm.loaded)?_c('div',{staticClass:"dmn-loading"},[_vm._v("\n    Loading booking widget...\n  ")]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-451e9458","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/js/components/DesignMyNight.vue
// module id = TxRm
// module chunks = 0